import apiBaseUrl from '../../utils/config.js';
import { authFetch } from '../../utils/authFetch.js';

class InsurancePatientInfoService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/insurancePatientInfo`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    return {
      'Content-Type': 'application/json',
    };
  }

  async #request(endpoint, method = 'GET', body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body !== null && body !== undefined) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await authFetch(`${this.baseUrl}${endpoint}`, options);

      const text = await response.text();

      let data = null;

      if (text) {
        try {
          data = JSON.parse(text);
        } catch {
          data = text;
        }
      }

      if (!response.ok) {
        const message =
          data?.message ||
          data?.error ||
          data ||
          `Request failed with status ${response.status}`;

        const err = new Error(message);
        err.status = response.status;
        err.data = data;
        throw err;
      }

      return data;
    } catch (error) {
      console.error(`Error during ${method} ${endpoint}:`, error);
      throw error;
    }
  }

  async saveOrUpdate(record) {
    return this.#request('/save', 'POST', record);
  }

  async getAllRecords() {
    return this.#request('/all');
  }

  async getById(id) {
    return this.#request(`/${id}`);
  }

  async getByPatientId(patientId) {
    return this.#request(`/patient/${patientId}`);
  }

  async deleteById(id) {
    return this.#request(`/delete/${id}`, 'DELETE');
  }

  async updateFields(id, updates) {
    return this.#request(`/update/${id}`, 'PATCH', updates);
  }

  async updateOfficeDoctor(id, officeId, doctorId) {
    return this.updateFields(id, {
      officeId: officeId || null,
      doctorId: doctorId || null,
    });
  }

  async getActiveAsList(id) {
    return this.#request(`/${id}/active`);
  }

  async addActiveValue(id, value) {
    const params = new URLSearchParams({ value });

    return this.#request(`/${id}/active/add?${params.toString()}`, 'POST');
  }

  async editActiveValue(id, oldValue, newValue) {
    const params = new URLSearchParams({
      oldValue,
      newValue,
    });

    return this.#request(`/${id}/active/edit?${params.toString()}`, 'PUT');
  }

  async searchByPatientId(patientId) {
    return this.#request(`/search?patientId=${encodeURIComponent(patientId)}`);
  }
}

export default InsurancePatientInfoService;